import {first, keys, last, sortBy} from 'lodash'

export function isNextVersion(fromVersion, toVersion) {
  return parseFloat(fromVersion) < parseFloat(toVersion)
}

export function isPreviousVersion(fromVersion, toVersion) {
  return parseFloat(fromVersion) > parseFloat(toVersion)
}

export function getNextVersion(version, versions){
  const nextUpdatesPairs = versions.filter(
    updateVersion => isNextVersion(version, updateVersion)
  )

  if (nextUpdatesPairs.length === 0){
    return null
  }

  const sortedUpdatePairs = sortBy(
    nextUpdatesPairs,
    parseFloat
  )

  return first(sortedUpdatePairs)
}

export function getPreviousVersion(version, versions){
  if (version === '00.00'){
    return null
  }

  const previousUpdatesPairs = versions.filter(
    updateVersion => isPreviousVersion(version, updateVersion)
  )

  if (previousUpdatesPairs.length === 0){
    return '00.00'
  }

  const sortedUpdatePairs = sortBy(
    previousUpdatesPairs,
    parseFloat
  )

  return last(sortedUpdatePairs)
}

export const getVersionNames = versions => sortBy(keys(versions), parseFloat)

export const getLastVersionName = versionNames => last(versionNames)
export const getFirstVersionName = versionNames => first(versionNames)
